import { ForecastMethods } from '@models/stable-balance/forecast-settings';
import { IStableBalanceCalibration } from '@models/stable-balance/stable-balance-calibration';

export const getForecastMethod = (calibration: IStableBalanceCalibration): any => {
  return typeof calibration.Settings.Forecast.ForecastMethod === 'string'
    ? calibration.Settings.Forecast.ForecastMethod
    : ForecastMethods[calibration.Settings.Forecast.ForecastMethod];
};
